export default {"src":"/_next/static/media/menu-01.2f9363c3.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};